export default "__VITE_ASSET__CbAw3_5I__"